import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeProvider';
import { applyTheme, readThemeMode } from './theme/theme';
import './styles.css';
// Loaded after the base sheet: it layers motion, focus and touch rules on top.
import './polish.css';
import './dashboard/dashboard.css';
import './auth/auth.css';

applyTheme(readThemeMode());

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

// Safari's own pinch gesture, refused only over the board, which does its own
// zooming. Refusing it document-wide — which is what this used to do — also
// took page zoom away from the dashboard and the forms, where nothing competes
// for the gesture and magnifying the text is the whole point.
document.addEventListener('gesturestart', (e) => {
  const target = e.target as HTMLElement | null;
  if (target?.closest('.board-canvas-host')) e.preventDefault();
});
document.addEventListener('contextmenu', (e) => {
  const target = e.target as HTMLElement | null;
  if (target?.closest('.board-canvas-host')) e.preventDefault();
});

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
